import SharedFilesDrawer from 'pages/mobile/Finance/shared/drawers/FilesDrawer';
import React from 'react';

import { useFactoringOperationDetail } from '../context';

const FilesDrawer: React.FC = () => {
  const { requestId } = useFactoringOperationDetail();
  return <SharedFilesDrawer requestId={requestId} requestType="factoring" />;
};

export default FilesDrawer;
